<template>
  <div>
    <h2 class="text-h5 mb-4">Роли пользователей</h2>
    <p class="mb-4 grey--text">
      Список всех доступных ролей в системе для справки
    </p>
    
    <v-simple-table>
      <template #default>
        <thead>
          <tr>
            <th class="text-left">Код роли</th>
            <th class="text-left">Описание</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="perm in permissions" :key="perm.code">
            <td>
              <code class="primary--text">{{ perm.code }}</code>
            </td>
            <td>{{ perm.name }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  name: 'RolesTab',
  props: {
    permissions: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
code {
  background-color: #f5f5f5;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 0.9em;
}
</style>
